// 导出页面为PDF格式
import html2Canvas from 'html2canvas';

export default {
  install(Vue) {
    Vue.prototype.getPdf = function (id, type) {
      const title = this.htmlTitle;
      console.log(id, document.querySelector(id));
      html2Canvas(document.querySelector(id || '#pdfDom'), {
        useCORS: true,
        onclone: dom => {
          const dom2 = dom.getElementsByClassName('print-title-info')[0];
          if (dom2) {
            dom2.style.display = 'flex';
            const title = dom2.getElementsByClassName('messgae-title')[0];
            if (title) {
              title.style.fontSize = '15px';
            }
          }
        },
      }).then(canvas => {
        const contentWidth = canvas.width;
        const contentHeight = canvas.height;
        const pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        const imgWidth = 595.28;
        const imgHeight = (592.28 / contentWidth) * contentHeight;
        const pageData = canvas.toDataURL('image/jpeg', 1.0);
        const PDF = new jsPDF('', 'pt', 'a4');
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        if (type) {
          // document.querySelector('#printIframe').contentWindow.print();
          PDF.save(`${title}.pdf`);
        } else {
          PDF.save(`${title}.pdf`);
        }
      });
    };
  },
};
